import { render, staticRenderFns } from "./PoSection.vue?vue&type=template&id=471c7487&"
import script from "./PoSection.vue?vue&type=script&lang=js&"
export * from "./PoSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports